// extracted by mini-css-extract-plugin
module.exports = {"title":"loader_title__Ea6aF","press":"loader_press__kOSOv"};